import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../services/auth-service/auth.service'
import {ActivatedRoute, Router} from '@angular/router';
import {Subscription, throwError} from 'rxjs';
import { UserLanguageService } from '../../services/user-language-service/user-language.service';
import { MatDialog } from '@angular/material/dialog';
import { LocalStorageService } from '../../services/localStorage-service/local-storage.service';
import {MatSnackBar} from '@angular/material/snack-bar';
@Component({
    selector: 'app-email-verification',
    templateUrl: './email-verification.component.html',
    styleUrls: ['./email-verification.component.scss'],
    standalone: false
})
export class EmailVerificationComponent implements OnInit {


  lang
  langSub: Subscription;

  labels;
  labelsSub: Subscription;

  header
  isSuccessfull: boolean = false
  hasFailed: boolean = false
  first: boolean = true
  showLoginPage: boolean = false
  hideSplashScreen: boolean =  false
  index: number = 1
  hideSpinner: boolean;
  constructor( private authService: AuthService, private route: ActivatedRoute, private router: Router, private languageService: UserLanguageService,
              public dialog: MatDialog,
              public snackBar: MatSnackBar,
              private localStorageService: LocalStorageService) {
    this.languageService.setLanguage('srb');
  }
  ngOnInit(): void {
    this.hideSpinner = false;
    this.authService.verifyEmail(this.route.snapshot.params['id'], this.route.snapshot.params['token']).subscribe(response => {
      this.hideSpinner = true;
      if(response === 'User verified'){
        this.isSuccessfull = true
        setTimeout(() => {
          this.goToLogin()
        }, 2500)
      } else {
        this.hasFailed = true
      }
    }, error => {
      this.hideSpinner = true;
      console.log("ERROR ", error)
      this.hasFailed = true
    })

  }

  goToLogin(){
    this.router.navigate(['/login'])
  }

  selectLang(lang) {
    this.languageService.setLanguage(lang);
  }

}
